// SIDEBAR AND HEADER CONSTANTS
export const SIDEBAR_WIDTH = 300
export const HEADER_HEIGHT = 64
